module.exports = __webpack_public_path__ + "img/cofidis.feac19f2.jpg";